import { all } from 'redux-saga/effects';
import listSagas from './list/sagas';
import redirectingToSagas from './redirectingTo/sagas';
import loaderSagas from './loader/sagas';

// Single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([listSagas(), redirectingToSagas(), loaderSagas()]);
}



// WEBPACK FOOTER //
// ./app/Sources/sagas.js